import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TAQLStore } from '@monorepo/types';
import { AqlUtil } from '@monorepo/utils';

export const selectAqlStore = createFeatureSelector<TAQLStore>('AQL_STORE');

export const getAqlSizeListInfo = createSelector(selectAqlStore, (state) => state.aqlDB.sizeQtyList);

export const getAqlLockDetailsAndNextCacheResetTimestamp = createSelector(selectAqlStore, (aqlStore) => {
  return {
    lockDetails: aqlStore.lockDetails,
    nextCacheResetTimestamp: aqlStore.aqlDB.nextCacheResetTimestamp,
  };
});
export const getSavedAuditData = createSelector(selectAqlStore, (state) => {
  return AqlUtil.getAllLinesFrontendMappedAqlList(state.aqlDB.persistanceCache.savedEvents);
});

export const getCurrentWeekAuditData = createSelector(
  selectAqlStore,
  (state) => state.aqlDB.dailyCache.currentWeekFailedEvents,
);

export const getCompletedEventsAcrossAllLines = createSelector(
  selectAqlStore,
  (state) => state.aqlDB.dailyCache.completedEvents,
);

export const getCurrentWeekFailedEventsData = createSelector(
  selectAqlStore,
  (state) => state.aqlDB.dailyCache.currentWeekFailedEvents,
);

export const getRecentCategoryList = createSelector(selectAqlStore, (store) => {
  return store.aqlDB.dailyCache.recentCategoryList;
});

export const getAllSaveEvents = createSelector(selectAqlStore, (store) => {
  return store.aqlDB.persistanceCache.savedEvents;
});
